module.exports = __webpack_public_path__ + "static/full02-eb8ab9a7f90eccf790f467ba71fe0515.png";